import { AttractionDetailsResponse } from '@grpc-clients/external/mercury/v1/attraction/attraction.pb';
import { AttractionProductOption } from '@grpc-clients/external/mercury/v1/attraction/common/attraction-product-option.pb';
import { ProductAvailabilityRange } from '@grpc-clients/external/mercury/v1/shared/product-availability-range.pb';
import { Action } from '@ngrx/store';
import { UppercaseGuestType } from '@shared/shared/interfaces/uppercase-guest-type';
import { GetActivitiesSearchResults } from './travel-activities-search.actions';

export const GET_ACTIVITIES_DETAILS = '[Travel Activities Details] Get activities details';
export const GET_ACTIVITIES_DETAILS_SUCCESS = '[Travel Activities Details] Get activities details Success';
export const GET_ACTIVITIES_DETAILS_FAILURE = '[Travel Activities Details] Get activities details Failure';
export const GET_ACTIVITIES_AVAILABLE_RANGES = '[Travel Activities Details] Get activities available ranges';
export const GET_ACTIVITIES_AVAILABLE_RANGES_SUCCESS =
  '[Travel Activities Details] Get activities available ranges Success';
export const GET_ACTIVITIES_AVAILABLE_RANGES_FAILURE =
  '[Travel Activities Details] Get activities available ranges Failure';
export const CHECK_ACTIVITIES_AVAILABILITY = '[Travel Activities Details] Check activities availability';
export const CHECK_ACTIVITIES_AVAILABILITY_SUCCESS =
  '[Travel Activities Details] Check activities availability Success';
export const CHECK_ACTIVITIES_AVAILABILITY_FAILURE =
  '[Travel Activities Details] Check activities availability Failure';
export const CLEAR_ACTIVITIES_AVAILABILITY = '[Travel Activities Details] Clear activities availability';
export const SELECT_ACTIVITIES_AVAILABILITY_OPTION =
  '[Travel Activities Details] Select activities availability option';
export const RESTORE_ACTIVITIES_AVAILABILITY_FORM = '[Travel Activities Details] Restore activities availability form';
export const RESTORE_ACTIVITIES_AVAILABILITY_SELECTED =
  '[Travel Activities Details] Restore activities availability selected';
export const CANCEL_RETRIEVE_ACTIVITIES_AVAILABILITY =
  '[Travel Activities Details] Cancel Retrieve Activities Availability';

export class GetActivitiesDetails implements Action {
  public readonly type = GET_ACTIVITIES_DETAILS;
  constructor(public id: number) {}
}
export class GetActivitiesDetailsSuccess implements Action {
  public readonly type = GET_ACTIVITIES_DETAILS_SUCCESS;
  constructor(public payload: AttractionDetailsResponse) {}
}

export class GetActivitiesDetailsFailure implements Action {
  public readonly type = GET_ACTIVITIES_DETAILS_FAILURE;
}

export class GetActivitiesAvailableRanges implements Action {
  public readonly type = GET_ACTIVITIES_AVAILABLE_RANGES;
  constructor(public id: number) {}
}
export class GetActivitiesAvailableRangesSuccess implements Action {
  public readonly type = GET_ACTIVITIES_AVAILABLE_RANGES_SUCCESS;
  constructor(public ranges: ProductAvailabilityRange[]) {}
}

export class GetActivitiesAvailableRangesFailure implements Action {
  public readonly type = GET_ACTIVITIES_AVAILABLE_RANGES_FAILURE;
}

export class CheckActivitiesAvailability implements Action {
  public readonly type = CHECK_ACTIVITIES_AVAILABILITY;
  constructor(
    public id: number,
    public date: Date,
    public guests: { type: UppercaseGuestType; value: number }[]
  ) {}
}
export class CheckActivitiesAvailabilitySuccess implements Action {
  public readonly type = CHECK_ACTIVITIES_AVAILABILITY_SUCCESS;
  constructor(
    public options: AttractionProductOption[],
    public productId: number
  ) {}
}

export class CheckActivitiesAvailabilityFailure implements Action {
  public readonly type = CHECK_ACTIVITIES_AVAILABILITY_FAILURE;
}
export class ClearActivitiesAvailability implements Action {
  public readonly type = CLEAR_ACTIVITIES_AVAILABILITY;
}

export class SelectActivitiesAvailabilityOption implements Action {
  public readonly type = SELECT_ACTIVITIES_AVAILABILITY_OPTION;
  constructor(
    public productId: number,
    public id: string
  ) {}
}

export class RestoreActivitiesAvailabilityForm implements Action {
  public readonly type = RESTORE_ACTIVITIES_AVAILABILITY_FORM;
  constructor(
    public id: number,
    public date: Date,
    public guests: { type: UppercaseGuestType; value: number }[]
  ) {}
}

export class CancelRetrieveActivitiesAvailability implements Action {
  public readonly type = CANCEL_RETRIEVE_ACTIVITIES_AVAILABILITY;
}

export class RestoreActivitiesAvailabilitySelected implements Action {
  public readonly type = RESTORE_ACTIVITIES_AVAILABILITY_SELECTED;
  constructor(public id: string) {}
}
export type ActivitiesDetailsActions =
  | GetActivitiesSearchResults
  | GetActivitiesDetails
  | GetActivitiesDetailsSuccess
  | GetActivitiesDetailsFailure
  | GetActivitiesAvailableRanges
  | GetActivitiesAvailableRangesSuccess
  | GetActivitiesAvailableRangesFailure
  | CancelRetrieveActivitiesAvailability
  | CheckActivitiesAvailability
  | CheckActivitiesAvailabilitySuccess
  | CheckActivitiesAvailabilityFailure
  | ClearActivitiesAvailability
  | SelectActivitiesAvailabilityOption
  | RestoreActivitiesAvailabilitySelected
  | RestoreActivitiesAvailabilityForm;
